export const COURSES = [
  {
    slug: "networking-essentials-training-kampala",
    title: "Networking Essentials",
    track: "LAN, WAN & Wi-Fi",
    level: "Beginner – Intermediate",
    duration: "2–4 weeks",
    summary: "Hands-on networking course in Kampala covering cabling, switching, routing, Wi-Fi and troubleshooting on real Cisco, MikroTik and Ubiquiti equipment.",
    audience: "IT support staff, fresh graduates and technicians moving into network roles.",
    outcomes: ["Design and cable a small office LAN", "Configure VLANs, DHCP, routing and VPNs", "Deploy and secure enterprise Wi-Fi", "Troubleshoot connectivity with professional tools"],
    modules: ["Networking fundamentals & IP addressing", "Structured cabling & fibre basics", "Switching, VLANs & routing (MikroTik/Cisco)", "Wireless networks & site surveys", "Firewalls, VPN & network security basics", "Capstone: build a branch network"],
  },
  {
    slug: "practical-cybersecurity-training-kampala",
    title: "Cybersecurity & Data Protection",
    track: "Security",
    level: "Intermediate",
    duration: "3 weeks",
    summary: "Practical cybersecurity training in Kampala: threat detection, firewalls, endpoint protection, incident response and Uganda Data Protection and Privacy Act compliance.",
    audience: "IT officers, system administrators and compliance teams in banks, NGOs and government.",
    outcomes: ["Harden Windows and Linux endpoints", "Configure FortiGate firewall policies", "Detect and respond to phishing and ransomware", "Prepare for data protection audits"],
    modules: ["Threat landscape in East Africa", "Firewalls & Fortinet Security Fabric", "Endpoint security & patching", "Identity, MFA & access control", "Incident response playbooks", "Data protection & compliance"],
  },
  {
    slug: "server-administration-training",
    title: "Server Administration",
    track: "Windows Server & Linux",
    level: "Intermediate – Advanced",
    duration: "4 weeks",
    summary: "Windows Server and Linux administration: Active Directory, file services, virtualization, backup and monitoring for production environments.",
    audience: "System administrators and IT staff managing on-premise or hybrid servers.",
    outcomes: ["Deploy Active Directory, DNS and Group Policy", "Administer Ubuntu/RHEL servers", "Run Hyper-V / VMware virtual machines", "Implement backup and disaster recovery"],
    modules: ["Windows Server & Active Directory", "Linux administration essentials", "Virtualization (Hyper-V, VMware)", "Storage, RAID & backup", "Monitoring & patch management", "Capstone: hybrid server lab"],
  },
  {
    slug: "microsoft-office-training-uganda",
    title: "Microsoft Office",
    track: "Digital Productivity",
    level: "Beginner",
    duration: "1–2 weeks",
    summary: "Microsoft 365 and Office productivity training: Word, Excel, PowerPoint, Outlook and Teams for staff teams and individuals in Uganda.",
    audience: "Office staff, students and teams moving to Microsoft 365.",
    outcomes: ["Create professional documents and reports", "Analyse data with Excel formulas and PivotTables", "Deliver presentations in PowerPoint", "Collaborate in Outlook, Teams and OneDrive"],
    modules: ["Word essentials", "Excel formulas, charts & PivotTables", "PowerPoint presentations", "Outlook & calendar management", "Teams & OneDrive collaboration"],
  },
  {
    slug: "cctv-installation-training-uganda",
    title: "CCTV & Surveillance Systems",
    track: "Physical Security",
    level: "Beginner – Intermediate",
    duration: "1 week",
    summary: "CCTV installation training covering IP cameras, NVRs, PoE cabling, remote viewing and maintenance using Hikvision and Dahua systems.",
    audience: "Technicians, security officers and facility managers.",
    outcomes: ["Plan camera placement and coverage", "Install and configure IP cameras and NVRs", "Set up mobile remote viewing", "Maintain and troubleshoot CCTV systems"],
    modules: ["Camera types & site planning", "PoE cabling & power", "NVR configuration & storage", "Remote viewing & alerts", "Maintenance & troubleshooting"],
  },
  {
    slug: "cloud-ai-fundamentals-training",
    title: "Cloud & AI Fundamentals",
    track: "Cloud Computing",
    level: "Intermediate",
    duration: "2 weeks",
    summary: "Introduction to AWS, Microsoft Azure and practical AI tools: cloud architecture, migration planning, cost control and responsible AI adoption.",
    audience: "IT managers, developers and decision-makers planning cloud or AI projects.",
    outcomes: ["Explain core AWS and Azure services", "Plan a cloud migration", "Control cloud costs and security", "Apply AI assistants to business workflows"],
    modules: ["Cloud models & architecture", "AWS & Azure core services", "Migration planning", "Cloud security & cost management", "Practical AI for business"],
  },
  {
    slug: "software-development-foundations-course",
    title: "Software Development Foundations",
    track: "Development",
    level: "Beginner – Intermediate",
    duration: "6 weeks",
    summary: "Learn to build modern web applications with HTML, CSS, JavaScript, React and Python APIs, with Git workflows and deployment.",
    audience: "Beginners, students and career-changers interested in software development.",
    outcomes: ["Build responsive web pages", "Write JavaScript and React components", "Create a Python REST API", "Use Git and deploy a project"],
    modules: ["HTML & CSS", "JavaScript fundamentals", "React basics", "Python & REST APIs", "Databases", "Git & deployment"],
  },
  {
    slug: "it-support-hardware-maintenance-training",
    title: "IT Support & Hardware Maintenance",
    track: "Technical Support",
    level: "Beginner",
    duration: "2 weeks",
    summary: "Practical IT support training: PC and laptop repair, Windows installation, printers, networking basics and helpdesk customer service.",
    audience: "Aspiring IT technicians and helpdesk staff.",
    outcomes: ["Diagnose and repair PC and laptop faults", "Install and configure Windows", "Set up printers and peripherals", "Deliver professional helpdesk support"],
    modules: ["PC hardware & components", "Windows installation & imaging", "Printers & peripherals", "Basic networking", "Helpdesk & ticketing"],
  },
]

export const getCourse = (slug) => COURSES.find((c) => c.slug === slug)
